// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vumeter-container {
  display: flex;
  flex-direction: row;
}

canvas#meter {
  vertical-align: top;
  flex: 1;
}

.clipping {
  width: 20px;
  background: #000;
  border: 3px solid #333;
}

.clipping.clipped {
  background: #F00;
}
`, "",{"version":3,"sources":["webpack://./src/components/meter/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".vumeter-container {\n  display: flex;\n  flex-direction: row;\n}\n\ncanvas#meter {\n  vertical-align: top;\n  flex: 1;\n}\n\n.clipping {\n  width: 20px;\n  background: #000;\n  border: 3px solid #333;\n}\n\n.clipping.clipped {\n  background: #F00;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
